export interface certification_form_response {
    id: number;
    name: string;
    description?: string;
    current_version: number;
    active: boolean;
    created_at?: string;
    updated_at?: string;
}

export class CertificationForm {
    public id: number = 0;
    public name: string = '';
    public description: string = '';
    public currentVersion: number = 1;
    public active: boolean = true;
    public createdAt?: Date;
    public updatedAt?: Date;

    public map(data: certification_form_response): this {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description ?? '';
        this.currentVersion = data.current_version;
        this.active = data.active;
        if (data.created_at) this.createdAt = new Date(data.created_at);
        if (data.updated_at) this.updatedAt = new Date(data.updated_at);
        return this;
    }

    public responsify(): certification_form_response {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            current_version: this.currentVersion,
            active: this.active,
        };
    }

    public static create(data: certification_form_response): CertificationForm {
        return new CertificationForm().map(data);
    }
}
